<template>
  <div class="liaison-box">
    <div class="box-head">
      <div>项目预警联系人</div>
      <el-button type="primary" @click="addFun">添加</el-button>
    </div>
    <div class="box-table">
      <el-table :data="tableData" height="100%" style="width: 100%">
        <template slot="empty">
          <p>{{dataText}}</p>
        </template>
        <el-table-column label="序号" width="100">
          <template slot-scope="scope">
            <span>{{ (scope.$index+1)+(currentPage-1)*pageSize }}</span>
          </template>
        </el-table-column>
        <el-table-column label="姓名">
          <template slot-scope="scope">
            <span>{{scope.row.name}}</span>
          </template>
        </el-table-column>
        <el-table-column label="手机号码">
          <template slot-scope="scope">
            <span>{{ scope.row.phone }}</span>
          </template>
        </el-table-column>
        <el-table-column label="岗位">
          <template slot-scope="scope">
            <span>{{ scope.row.jobTypeName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="备注">
          <template slot-scope="scope">
            <span>{{ scope.row.note }}</span>
          </template>
        </el-table-column>
        <el-table-column label="时间">
          <template slot-scope="scope">
            <span>{{ scope.row.createDate }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="delFun(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
    </el-table>
    </div>
    <!-- 分页展示 -->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalItems"
    ></el-pagination>
    <!-- 添加/编辑弹出框 -->
    <el-dialog
      :title="diaTitle"
      :visible.sync="dialogVis"
      center
      :append-to-body="true"
      :lock-scroll="false"
      class="add-form"
      width="500px"
    >
      <el-form ref="form" :model="form" :rules="rules" label-width="120px">
        <el-form-item label="姓名：" prop="name">
          <el-input v-model="form.name" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="手机号码：" prop="phone">
          <el-input v-model="form.phone" placeholder="请输入手机号码"></el-input>
        </el-form-item>
        <el-form-item label="岗位：">
          <el-select v-model="form.jobType" filterable placeholder="请选择岗位">
            <el-option v-for="(item,index) in jobTypeList" :key="index" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注：">
          <el-input type="textarea" :rows="2" placeholder="请输入备注" v-model="form.note"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="dialogVis=false">取消</el-button>
          <el-button type="primary" @click="submitForm('form')">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import myHttp from '../../../untils/port'
import util from '../../../untils/util'
export default {
  data(){
    var checkphone = (rule, value, callback) => {
      if (value == '') {
        callback(new Error('请输入手机号'))
      } else if (!this.isCellPhone(value)) {
          //引入methods中封装的检查手机格式的方法
        callback(new Error('请输入正确的手机号!'))
      } else {
        callback()
      }
    }
    return{
      groupId:'',
      tableData:[],
      dataText:'数据加载中...',
      //分页
      currentPage:1,
      pageSize:10,
      totalItems:0,
      //弹出框
      diaTitle:'',
      dialogVis:false,
      form:{
        id:'',
        projectId:'',
        name:'',
        phone:'',
        note:'',
        createBy:'',
        jobType:''
      },
      rules:{
        name:[{required: true, message: '请输入姓名', trigger: 'blur'}],
        phone: [{ required: true, validator: checkphone, trigger: 'blur' }]
      },
      jobTypeList:[],//岗位列表
    }
  },
  mounted(){
    this.groupId = util.session.get('groupId')
    this.getJobType()
    this.getData()
  },
  methods:{
    //检查手机号
    isCellPhone(val) {
      if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(val)) {
        return false
      } else {
        return true
      }
    },
    //分页查询
    handleSizeChange(val){
      this.pageSize = val
      this.handleCurrentChange(this.currentPage)
    },
    handleCurrentChange(val){
      this.currentPage = val
      this.getData();
    },
    //获取信息
    getData(){
      var that = this
      myHttp.getProjectWarningContactByProjectIdPageList({
        projectId:this.groupId,
        pageNum:this.currentPage,
        pageSize:this.pageSize
      }).then(function(resp){
        if(resp.data.code=='200'){
          var list = resp.data.data.entity.list||[]
          that.tableData = list
          that.totalItems = resp.data.data.entity.total||0
          if(list.length==0){
            that.dataText = '暂无数据'
          }
        }else{
          that.dataText = '暂无数据'
        }
      })
    },
    //获取岗位类型字典表
    getJobType(){
      var that = this
      myHttp.getDictByType({
        type:'job_type'
      }).then(resp=>{
                  console.log(resp)
        if(resp.data.code=='200'){
          var list = resp.data.data.dictList||[]
          this.jobTypeList = list
        }
      },error=>{})
    },
    //添加
    addFun(){
      this.dialogVis = true
      this.form = {
        id:'',
        projectId:'',
        name:'',
        phone:'',
        note:'',
        createBy:'',
        jobType:''
      }
      this.diaTitle = '添加预警联系人'
    },
    //编辑
    handleEdit(index,row){
      this.dialogVis = true
      this.form.id = row.id
      this.form.name = row.name
      this.form.phone = row.phone
      this.form.note = row.note
      this.form.jobType = row.jobType
      this.diaTitle = '编辑预警联系人'
    },
    //删除
    delFun(index,row){
      var that = this
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        myHttp.deleteProjectWarningContact({
          id: row.id
        }).then(function(resp) {
          if (resp.data.code == '200') {
            that.$message({
              type: 'success',
              message: '删除成功!'
            })
            that.getData()
          } else {
            that.$message.error(resp.data.msg)
          }
        })
      }).catch(err => {})
    },
    //提交
    submitForm(formName){
      console.log(formName)
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.form.projectId = this.groupId
          if(this.form.id==''){
            this.form.createBy = util.session.get('user').id
            myHttp.addProjectWarningContact(this.form).then(resp=>{
                        console.log(resp.data.code,'999888')
              if(resp.data.code=='200'){
                this.$message.success('添加成功')
                this.dialogVis = false
                this.getData()
              }else{
                this.$message.error(resp.data.msg)
              }
            })
          }else{
            this.form.updateBy = util.session.get('user').id
            myHttp.editProjectWarningContact(this.form).then(resp=>{
              if(resp.data.code=='200'){
                this.$message.success('编辑成功')
                this.dialogVis = false
                this.getData()
              }else{
                this.$message.error(resp.data.msg)
              }
            })
          }
        } else {
          return false;
        }
      });
    },

  }
}
</script>

<style scoped>
  .liaison-box{
    width: 100%;
    height: 100%;
    position: relative;
    background: #fff;
  }
  .box-head{
    width: 100%;
    height: 7vh;
    position: relative;
    display: flex;
    align-content: center;
    align-items: center;
    padding: 0 1vw;
    border-bottom: 1px solid #409EFF;
    justify-content: space-between;
  }
  .box-table{
    width: 100%;
    height: calc( 100% - 13vh );
    position: relative;
  }
</style>

<style>
  @import '../../../assets/css/common.css';
</style>